import React from "react";
import Box from "@vapor/react-material/Box";

export type ToolbarItemProps = {
  children?: React.ReactNode;
  sx?: any;
};

export const ToolbarItem = (props: ToolbarItemProps) => {
  const { sx, ...children } = props;

  return (
    <Box
      sx={{
        px: 0.5,
        display: "flex",
        alignItems: "center",
        ...sx
      }}
      {...children}
    />
  );
};
